<template>
  <a-modal
    :open="open"
    title="個人資料尚未填寫"
    :maskClosable="false"
    :closable="false"
    :footer="null"
    centered
  >
    <div class="modal-body">
      <p>
        您的個人資料尚未完成，您可稍後登入至個人後台補填。完成後即可解鎖平台完整功能。
      </p>
    </div>
    <div class="modal-footer-custom">
      <a-button @click="$emit('leave')">離開</a-button>
      <a-button type="primary" @click="$emit('stay')">繼續註冊</a-button>
    </div>
  </a-modal>
</template>

<script setup>
defineProps({
  open: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["leave", "stay"]);
</script>

<style scoped>
.modal-body {
  font-size: 16px;
  color: #333;
  line-height: 1.5;
  margin: 20px 0;
}

.modal-footer-custom {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}
</style>
